import axios from 'axios';
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies, import/extensions
import config from 'config';

const qs = require('qs');

const state = {
	knowledges: {},
	activatedKnowledges: {},
	disabledKnowledges: {},
	intents: {},
	intent: {},
	pendingThemes: {},
};

const actions = {
	getActiveKnowledges: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(
			`${config.api}/politician/${payload.userId}/intent`,
			{
				params: {
					api_key: payload.apiKey,
					filter: 'active',
					sync: payload.sync || 0,
				},
			},
		).then((response) => {
			resolve(response);
			commit('setActiveKnowledges', response.data, { root: true });
		}).catch((error) => {
			reject(error);
			commit('statusCheck', error.response.status);
		});
	}),
	getPendingThemes: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(
			`${config.api}/politician/${payload.userId}/intent/pending`,
			{
				params: {
					api_key: payload.apiKey,
					sync: payload.sync || 0,
				},
			},
		).then((response) => {
			resolve(response);
			commit('setPendingThemes', response.data, { root: true });
		}).catch((error) => {
			reject(error);
			commit('statusCheck', error.response.status);
		});
	}),
	editKnowledge: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'PUT',
				headers: { 'Content-Type': 'multipart/form-data' },
				url: `${config.api}/politician/${rootState.userId}/knowledge-base/${payload.get('myKnowledgeId')}?api_key=${rootState.apiKey}`,
				data: payload,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
	newKnowledge: ({ commit, rootState }, payload) =>
		new Promise((resolve, reject) => {
			axios({
				method: 'POST',
				headers: { 'Content-Type': 'multipart/form-data' },
				url: `${config.api}/politician/${rootState.userId}/knowledge-base?api_key=${rootState.apiKey}`,
				data: payload,
			}).then((response) => {
				resolve(response);
				commit('setSuccess');
			}).catch((error) => {
				reject(error);
				commit('setError', error.response.data, { root: true });
				commit('statusCheck', error.response.status);
			});
		}),
	getIntents: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/intent?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setIntents', response.data, { root: true });
			}).catch((error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
	getIntent: ({ commit }, payload) => new Promise((resolve, reject) => {
		axios.get(`${config.api}/politician/${payload.userId}/intent/${payload.intentId}?api_key=${payload.apiKey}`)
			.then((response) => {
				resolve(response);
				commit('setIntent', response.data);
			}, (error) => {
				reject(error);
				commit('statusCheck', error.response.status);
			});
	}),
};

const mutations = {
	setActiveKnowledges(state, payload) {
		state.knowledges = payload;
	},
	setActivatedKnowledges(state, payload) {
		state.activatedKnowledges = payload;
	},
	setDisabledKnowledges(state, payload) {
		state.disabledKnowledges = payload;
	},
	setIntents(state, payload) {
		state.intents = payload;
	},
	setIntent(state, payload) {
		state.intent = payload;
	},
	setPendingThemes(state, payload) {
		state.pendingThemes = payload;
	},
};

export default {
	state,
	mutations,
	actions,
};



// WEBPACK FOOTER //
// ./_source/javascripts/modules/entity/store.js